/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GameControllerDtoMaterialConfigInfoMaterialConfigInfoData model module.
 * @module model/GameControllerDtoMaterialConfigInfoMaterialConfigInfoData
 * @version 1.0
 */
class GameControllerDtoMaterialConfigInfoMaterialConfigInfoData {
    /**
     * Constructs a new <code>GameControllerDtoMaterialConfigInfoMaterialConfigInfoData</code>.
     * @alias module:model/GameControllerDtoMaterialConfigInfoMaterialConfigInfoData
     */
    constructor() { 
        
        GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GameControllerDtoMaterialConfigInfoMaterialConfigInfoData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GameControllerDtoMaterialConfigInfoMaterialConfigInfoData} obj Optional instance to populate.
     * @return {module:model/GameControllerDtoMaterialConfigInfoMaterialConfigInfoData} The populated <code>GameControllerDtoMaterialConfigInfoMaterialConfigInfoData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GameControllerDtoMaterialConfigInfoMaterialConfigInfoData();

            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemType')) {
                obj['itemType'] = ApiClient.convertToType(data['itemType'], 'Number');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('coinType')) {
                obj['coinType'] = ApiClient.convertToType(data['coinType'], 'Number');
            }
            if (data.hasOwnProperty('property1')) {
                obj['property1'] = ApiClient.convertToType(data['property1'], 'Number');
            }
            if (data.hasOwnProperty('property2')) {
                obj['property2'] = ApiClient.convertToType(data['property2'], 'Number');
            }
            if (data.hasOwnProperty('property3')) {
                obj['property3'] = ApiClient.convertToType(data['property3'], 'Number');
            }
            if (data.hasOwnProperty('gemColor')) {
                obj['gemColor'] = ApiClient.convertToType(data['gemColor'], 'Number');
            }
            if (data.hasOwnProperty('gemEffect')) {
                obj['gemEffect'] = ApiClient.convertToType(data['gemEffect'], 'Number');
            }
            if (data.hasOwnProperty('gemEffectValue')) {
                obj['gemEffectValue'] = ApiClient.convertToType(data['gemEffectValue'], 'Number');
            }
            if (data.hasOwnProperty('upgradeItemId')) {
                obj['upgradeItemId'] = ApiClient.convertToType(data['upgradeItemId'], 'Number');
            }
            if (data.hasOwnProperty('expireAt')) {
                obj['expireAt'] = ApiClient.convertToType(data['expireAt'], 'Date');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GameControllerDtoMaterialConfigInfoMaterialConfigInfoData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GameControllerDtoMaterialConfigInfoMaterialConfigInfoData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }

        return true;
    }


}



/**
 * @member {Number} itemId
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['itemId'] = undefined;

/**
 * @member {Number} itemType
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['itemType'] = undefined;

/**
 * @member {String} itemName
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['itemName'] = undefined;

/**
 * @member {Number} level
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['level'] = undefined;

/**
 * @member {Number} coinType
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['coinType'] = undefined;

/**
 * @member {Number} property1
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['property1'] = undefined;

/**
 * @member {Number} property2
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['property2'] = undefined;

/**
 * @member {Number} property3
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['property3'] = undefined;

/**
 * @member {Number} gemColor
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['gemColor'] = undefined;

/**
 * @member {Number} gemEffect
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['gemEffect'] = undefined;

/**
 * @member {Number} gemEffectValue
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['gemEffectValue'] = undefined;

/**
 * @member {Number} upgradeItemId
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['upgradeItemId'] = undefined;

/**
 * @member {Date} expireAt
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['expireAt'] = undefined;

/**
 * @member {Number} sort
 */
GameControllerDtoMaterialConfigInfoMaterialConfigInfoData.prototype['sort'] = undefined;






export default GameControllerDtoMaterialConfigInfoMaterialConfigInfoData;

